import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminApiService } from "../../../services/adminApiService";

interface AdminProductsState {
  productsListData: any[];
  productsListPagination: any;
  isLoadingList: boolean;
  error: string | null;
}

const initialState: AdminProductsState = {
  productsListData: [],
  productsListPagination: null,
  isLoadingList: false,
  error: null,
};

export const fetchAdminProducts = createAsyncThunk(
  "adminProducts/fetchProducts",
  async (params: any, { rejectWithValue }) => {
    try {
      return await adminApiService.getProducts(params);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const adminProductsSlice = createSlice({
  name: "adminProducts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminProducts.pending, (state) => {
        state.isLoadingList = true;
        state.error = null;
      })
      .addCase(fetchAdminProducts.fulfilled, (state, action) => {
        state.isLoadingList = false;
        state.productsListData = action.payload.data?.products || [];
        state.productsListPagination = action.payload.data?.pagination || null;
      })
      .addCase(fetchAdminProducts.rejected, (state, action) => {
        state.isLoadingList = false;
        state.error = action.payload as string;
      });
  },
});

export default adminProductsSlice.reducer;
